module.exports = new __parcel__URL__("cornershop-shopper-ios.94a89cdd.webp").toString();